<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <h4>AKB48 53rd 報名狀況</h4>
    </nav>
    <router-view/>
  </div>
</template>

<script>

import firebase from 'firebase'
import {
  mapActions
} from 'vuex'

export default {
  name: "",
  data: () => ({

  }),
  methods: {
    ...mapActions([
      'updateUid',
    ])
  },
  mounted() {
    //do something after creating vue instance
    firebase.auth().signInAnonymously().catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
    });
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        var isAnonymous = user.isAnonymous;
        var uid = user.uid;
        this.updateUid(uid)
        console.log(uid);
        // ...
      } else {
        // User is signed out.
        // ...
      }
      // ...
    });
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue